import React from 'react';
import * as IptC from './_ccbIptC';
import * as TextC from './_ccbTextC';
import * as BtnC from './_cccBtnC';
import * as GridC from './_cccGridC';
import * as LblC from './_cccLblC';
import * as BtnsC from './_ccmBtnsC';
import * as HdrC from './_ccmHdrC';
import * as RootC from './_ccmRootC';
import * as SchC from './_ccmSchC';
import * as TblC from './_ccmTblC';
import * as _cm from './_cm';
import { a } from './_cmABT';
import * as _cmFLE from './_cmFLE';
import * as _cmFTH from './_cmFTH';
import * as _cr from './_cr';
import * as _gv from './_gv';
import * as _ls from './_csLcl';
import { useNgnz } from './_csNgn';
import { useFilez } from './_csMdlFile';
import { useCfmz } from './_csMdlCfm';
import * as _hm from './_hm';
import * as _hmDTM from './_hmDTM';
import * as _ht from './_ht';

import * as icm from './icm';
import * as icv from './icv';
import * as icvBaseM10Rz from './icvBaseM10Rz';

const $cz = {
  tgt: '販売店'
};

let $i11z = {} as _ht.dz;

let $i11rs = [] as _ht.ls;

let $i11r_fst = -1;

let $i12rs = [] as _ht.ls; // 店種
let $i15rs = [] as _ht.ls; // 地区
let $i18rs = [] as _ht.ls; // 支払方法

const $schz = {
  word: '',
};

const $eptCsv1 = () => { // 販売店CSV

//_hm.l(`icvI11M10Rz 49: ${_hm.s($i15rs)}`)
  const _bdys = $i11rs.map( (_i11rz: _ht.dz) => {
//_hm.l(`icvI11M10Rz 50: ${_i11rz.i11ri15r1f}, ${_cm.r($i15rs, _i11rz.i11ri15r1f)?.text}`)
    return {
      1: _i11rz._icn ?? '',
      2: _i11rz._pfx ?? '',
      3: _cm.r(icv.lz.i11rs1100i, _i11rz.i11rs1100i)?.text ?? '',
      4: _cm.r($i12rs, _i11rz.i11rt1100i)?.text ?? '',
      5: _cm.r($i15rs, _i11rz.i11ri15r1f)?.text ?? '',
      6: _i11rz.i11ra2100s ?? '',
      7: _i11rz.i11ra2200s ?? '',
      8: _i11rz.i11ra4100s ?? '',
      9: _cm.r($i18rs, _i11rz.i11ri18r1f)?.text ?? '',
      10: _i11rz.i11ra3100s ?? '',
      11: _i11rz.i11ra3120s ?? '',
      12: _i11rz.i11ra6100s ?? '',
      13: _i11rz.i11ra7110r ?? '',
      14: _i11rz.i11ra7120r ?? '',
    }
  });

  _cmFLE.eptCsv({
    hdrz: {
      1: '顧客NO', //
      2: '販売店名',
      3: '契約状況',
      4: '店種',
      5: '地区',
      6: '郵便番号',
      7: '所在地',
      8: '電話番号',
      9: '支払方法',
      10: '契約者',
      11: '契約者カナ',
      12: '備考',
      13: '経度',
      14: '緯度',
    },
    bdys: _bdys,
    fileName: `販売店_${_hmDTM.getTdy()}.csv`,
  })  

};

const $iptCsvAsync1 = (pz: {
  sPz: _ht.dz,
  sFilez: _ht.dz,
  sCfmz: _ht.dz
}) => {
  pz.sFilez.show({
    mode: 'c',
    onRead: async (_dz: _ht.dz) => {
      const _errs = [] as _ht.ls;
      _hm.ectSrlAsync(_dz.ls.map((_dz2: _ht.dz) => async () => {
//        const _i11r_icn = _hm.pdg(_dz2['顧客NO'], 6, '0');
        //_hm.l('icvI11M10Rz 104: ' + _dz2['顧客NO']);
        const _i11r_icn = _hm.f(_dz2['顧客NO']) ? _hm.pdg(_dz2['顧客NO'], 6, '0') : '';
        let _i11ra7110r = _dz2['経度'];
        let _i11ra7120r = _dz2['緯度'];
        if (!_hm.f(_i11ra7110r) || !_hm.f(_i11ra7120r)) {
          const _dz = await icm.cvtLcnAsync(_dz2['所在地']);
          _i11ra7110r = _dz.k;
          _i11ra7120r = _dz.i;
        }
        const _i11z = 
        _hm.f(_dz2['顧客NO']) ? 
        await _cmFTH.loadDzAsync2({
          tgt: 'i11r.loadI11zDzAsync',
          i11r_icn: _i11r_icn,
        })
        : 
        {
          _i11rz: {},
        };
        const _i11rz = {
          ... _i11z.i11rz,
          _icn: _i11r_icn,
          _pfx: _dz2['販売店名'],
          i11ri15r1f: _hm.getDz($i15rs, _dz2['地区'], '_pfx')?._fst ?? -1,
          i11ri18r1f: _hm.getDz($i18rs, _dz2['支払方法'], '_pfx')?._fst ?? -1,
          i11rs1100i: _hm.getDz(icv.lz.i11rs1100i, _dz2['契約状況'], 'text')?.key ?? -1,
          i11rt1100i: _hm.getDz($i12rs, _dz2['店種'], 'text')?.key ?? -1,
          i11ra2100s: _dz2['郵便番号'] ?? '',
          i11ra2200s: _dz2['所在地'] ?? '',
          i11ra3100s: _dz2['契約者'] ?? '',
          i11ra3120s: _dz2['契約者カナ'] ?? '',
          i11ra4100s: _dz2['電話番号'] ?? '',
          i11ra6100s: _dz2['備考'] ?? '',
          i11ra7110r: _i11ra7110r,
          i11ra7120r: _i11ra7120r,
          _dlt: _dz2['削除区分'] == '削除' ? 1 : -1,
        }
//_hm.l(`icvI11M10Rz 130: ${_i11r_icn}, ${_i11rz.i11ri15r1f}, ${_i11rz.i11ri18r1f}, ${_i11rz.i11rt1100i}`)
        if ( _i11rz.i11ri15r1f > 0 && _i11rz.i11ri18r1f > 0 && _i11rz.i11rs1100i > 0 && _i11rz.i11rt1100i > 0 ) {
//_hm.l(`icvI11M10Rz 132: ${_i11r_icn}, ${_hm.s(_i11rz)}`)
          await _cmFTH.ugdDzAsync2({
            tgt: 'i11r.ugdI11zDzAsync',
            i11z: { 
              i11rz: _i11rz
            },
          });
        }
        else {
          _errs.push(_dz2['顧客NO']);
        }
        return true;
      }))
      .then(() => {
        if (_errs.length > 0) {
          pz.sCfmz.show({
            text: `取り込みを完了しましたが、地区・支払方法・契約状況・店種のいずれかが適切でないため、一部のデータは取り込まれませんでした（顧客NO：${_errs.join(', ')}）`,
            ls: [
              { key: 1, text: 'はい' },
            ],
          });
        }
        else {
          pz.sCfmz.show({
            text: '取り込みを完了しました',
            ls: [
              { key: 1, text: 'はい' },
            ],
          });
        }
        $schAsync(pz.sPz.udtAll);
      });
    }
  });                      
};

const $schAsync = async (
  frcUdt?: () => void
) => {
  $i11rs = await _cmFTH.loadLsAsync2({
    tgt: 'i11r.loadI11zLsAsync',
    ... $schz,
  });
  if (frcUdt) frcUdt();
};

export const R = (pz: {
  sRz: _ht.dz,
}) => {

  const _sPz = _ls.usePz({
    steps: [0],
    phs: 'd',
  });

  return (
    _cr.c(icvBaseM10Rz.N, {},
      _cr.c(RootC.N, {
        sPz: _sPz,
        hdrClds: [
          _cr.c(H, {
            sPz: _sPz,
          })
        ],
        schStlz: a(`dwx/w3`),
        schClds: [
          _cr.c(S, {
            sPz: _sPz,
          })
        ],
        btnClds: [
          _cr.c(B, {
            sPz: _sPz,
          })
        ],
        topStlz: a(`dwx/w3`),
        topClds: [
          _cr.c(T, {
            sPz: _sPz,
          })
        ],
        cttClds: [
          _cr.c(C, {
            sPz: _sPz,
          })
        ],
      })
    )
  );

};

export const H = (pz: {
  sPz: _ht.dz,
}) => {
  return (
    _cr.c(HdrC.N, {
      sPz: pz.sPz,
      abtz: icv.abtz.mainHdrz,
      cz: {
        tgt: $cz.tgt
      }
    })
  );
};

export const S = (pz: {
  sPz: _ht.dz,
}) => {
  return (
    _cr.c(SchC.N, {
      sPz: pz.sPz,
      abtz: {
        btnSchz: icv.abtz.btnSchz,
        gridSchz: icv.abtz.gridSchz,
      },
      schClds: [
        _cr.c(IptC.N, {
          cz: {
            bEdit: true,
            iptType: 't',
            vle: $schz.word,
            onChg: (_s: _ht.s) => {
              $schz.word = _s;
            },
          },
          iptPtyz: a(`ipt/顧客NO、販売店名 ipc/lt3`),
        }),
      ],
      onSch: () => $schAsync(pz.sPz.udtAll),
    })
  );
};

export const T = (pz: {
  sPz: _ht.dz,
}) => {

  const _udtThis = _ls.udtThis();
  const _gUserz = _gv.useUserz();

  React.useEffect(() => {
    if (
      _gUserz.crt._20rz._key > 0 && 
      pz.sPz.crt.steps[0] == 0
    ) {
      _hm.ectSrlAsync([
        async () => {
          $i12rs = await _cmFTH.loadLsAsync2({
            tgt: 'i12r.loadI12zLsAsync',
          });
        },
        async () => {
          $i15rs = await _cmFTH.loadLsAsync2({
            tgt: 'i15r.loadI15zLsAsync',
          })
        },
        async () => {
          $i18rs = await _cmFTH.loadLsAsync2({
            tgt: 'i18r.loadI18zLsAsync',
          })
        },
        async () => {
          await $schAsync(_udtThis);
        },
      ])
    }
  }, [
    _gUserz.crt._20rz._key,
    pz.sPz.crt.steps[0]
  ])



  const _hdrCs = [
    {
      cellCs: [
        {
          boxStlz: a(`dw/icn`),
          boxClds: [
            _cr.c(TextC.N, {
              abtz: icv.abtz.textLblz,
              text: '顧客NO',
            }),
          ]
        },
        {
          boxStlz: a(`f/1`),
          boxClds: [
            _cr.c(TextC.N, {
              abtz: icv.abtz.textLblz,
              text: `${$cz.tgt}名`,
            }),
          ]
        },
        {
          boxStlz: a(`dw/btn`),
          boxClds: [

          ]
        }
      ]
    }
  ];

  const _bdyCs = $i11rs?.map((_i11rz: _ht.dz) => {
    return (
      {
        cellCs: [
          {
            boxStlz: a(`dw/icn`),
            boxClds: [
              _cr.c(TextC.N, {
                abtz: icv.abtz.textVlez,
                text: `${_i11rz._icn}`,
              }),
            ]
          },
          {
            boxStlz: a(`f/2 fd/rsc`),
            boxClds: [
              _cr.c(TextC.N, {
                abtz: icv.abtz.textVlez,
                text: `${_i11rz._pfx}`,
              }),
            ]
          },
          {
            boxStlz: a(`dw/btn`),
            boxClds: [

              _cr.c(BtnC.N, {
                abtz: icv.abtz.btnDtlz,
                frmCz: {
                  pslPtyz: {
                    onPrs: () => {
                      $i11r_fst = _i11rz._fst;
                      pz.sPz.set({
                        steps: [1],
                        phs: 'd',
                      })
                    }
                  }            
                },
              }),

            ]
          }
        ]
      }
    );
  });

  return (
    _cr.c(TblC.N, {
      abtz: icv.abtz.tblLinez,
      hdrCz: {
        abtz: icv.abtz.gridTblHdrz,
        lineCs: _hdrCs,
      },
      bdyCz: {
        abtz: icv.abtz.gridTblBdyz,
        lineCs: _bdyCs
      }
    })

  );

};

export const C = (pz: {
  sPz: _ht.dz,
}) => {

  const _udtThis = _ls.udtThis();

  React.useEffect(() => {
    _hm.ectSrlAsync([
      async () => {
        if ( pz.sPz.crt.steps[0] == 1 && pz.sPz.crt.phs == 'c' ) { // 初期化
          $i11z = {
            i11rz: {
              i11rs1100i: 20,
            },
          };
          _udtThis();
        };
        if ( pz.sPz.crt.steps[0] == 1 && pz.sPz.crt.phs == 'd' ) { // 更新
          _cmFTH.loadDzAsync2({
            tgt: 'i11r.loadI11zDzAsync',
            i11r_fst: $i11r_fst
          })
          .then((_i11z: _ht.dz) => {
            $i11z = _i11z;
            _udtThis();
          });
        };
      },
    ])
  }, [
    pz.sPz.crt.steps[0],
    pz.sPz.crt.phs
  ])

  return (
    _cr.c(GridC.N, {
      abtz: icv.abtz.gridCttz,
      lineCs: [
        {
          cellCs: [
            {
              boxClds: [
                _cr.c(LblC.N, {
                  abtz: icv.abtz.lblHzlz,
                  lblCz: {
                    text: '顧客NO：',
                  },
                  cttCz: {
                    boxClds: [
                      _cr.c(IptC.N, {
                        cz: {
                          iptType: 't',
//                          bEdit: _hm.i(pz.sPz.crt.phs, ['c', 'u']),
                          bEdit: false,
                          vle: $i11z.i11rz?._icn ?? '※ 登録時に自動付番',
                          onChg: (_s: _ht.s) => {
                            _cm.u($i11z.i11rz, {
                              _icn: _s,
                            });
                          }
                        }
                      }),
                    ]
                  },
                }),
              ]
            },
          ]
        },
        {
          cellCs: [
            {
              boxClds: [
                _cr.c(LblC.N, {
                  abtz: icv.abtz.lblHzlz,
                  lblCz: {
                    text: `${$cz.tgt}名：`,
                  },
                  cttCz: {
                    boxClds: [
                      _cr.c(IptC.N, {
                        cz: {
                          iptType: 't',
                          bEdit: _hm.i(pz.sPz.crt.phs, ['c', 'u']),
                          vle: $i11z.i11rz?._pfx,
                          onChg: (_s: _ht.s) => {
                            _cm.u($i11z.i11rz, {
                              _pfx: _s,
                            });
                          }
                        }
                      }),
                    ]
                  },
                }),
              ]
            },
          ]
        },
        {
          cellCs: [
            {
              boxClds: [
                _cr.c(LblC.N, {
                  abtz: icv.abtz.lblHzlz,
                  lblCz: {
                    text: '契約状況：',
                  },
                  cttCz: {
                    boxClds: [
                      _cr.c(IptC.N, {
                        cz: {
                          iptType: 'p',
                          bEdit: _hm.i(pz.sPz.crt.phs, ['c', 'u']),
//                          ls: icv.lz.i11rt1100i,
                          ls: icv.lz.i11rs1100i,
                          vle: $i11z.i11rz?.i11rs1100i,
                          onChg: (_dz: _ht.dz) => {
                            _cm.u($i11z.i11rz, {
                              i11rs1100i: _dz.key,
                            });
                          }
                        }
                      }),
                    ]
                  },
                }),
              ]
            },
          ]
        },
        {
          cellCs: [
            {
              boxClds: [
                _cr.c(LblC.N, {
                  abtz: icv.abtz.lblHzlz,
                  lblCz: {
                    text: '店種：',
                  },
                  cttCz: {
                    boxClds: [
                      _cr.c(IptC.N, {
                        cz: {
                          iptType: 'p',
                          bEdit: _hm.i(pz.sPz.crt.phs, ['c', 'u']),
//                          ls: icv.lz.i11rt1100i,
                          ls: $i12rs,
                          vle: $i11z.i11rz?.i11rt1100i,
                          onChg: (_dz: _ht.dz) => {
                            _cm.u($i11z.i11rz, {
                              i11rt1100i: _dz.key,
                            });
                          }
                        }
                      }),
                    ]
                  },
                }),
              ]
            },
          ]
        },
        {
          cellCs: [
            {
              boxClds: [
                _cr.c(LblC.N, {
                  abtz: icv.abtz.lblHzlz,
                  lblCz: {
                    text: '地区：',
                  },
                  cttCz: {
                    boxClds: [
                      _cr.c(IptC.N, {
                        cz: {
                          iptType: 'p',
                          bEdit: _hm.i(pz.sPz.crt.phs, ['c', 'u']),
                          ls: $i15rs,
                          vle: $i11z.i11rz?.i11ri15r1f,
                          onChg: (_dz: _ht.dz) => {
                            _cm.u($i11z.i11rz, {
                              i11ri15r1f: _dz.key,
                            });
                          }
                        }
                      }),
                    ]
                  },
                }),
              ]
            },
          ]
        },
        {
          cellCs: [
            {
              boxClds: [
                _cr.c(LblC.N, {
                  abtz: icv.abtz.lblHzlz,
                  lblCz: {
                    text: '郵便番号：',
                  },
                  cttCz: {
                    boxClds: [
                      _cr.c(IptC.N, {
                        cz: {
                          iptType: 't',
                          bEdit: _hm.i(pz.sPz.crt.phs, ['c', 'u']),
                          vle: $i11z.i11rz?.i11ra2100s,
                          onChg: (_s: _ht.s) => {
                            _cm.u($i11z.i11rz, {
                              i11ra2100s: _s,
                            });
                          }
                        }
                      }),
                    ]
                  },
                }),
              ]
            },
          ]
        },
        {
          cellCs: [
            {
              boxClds: [
                _cr.c(LblC.N, {
                  abtz: icv.abtz.lblHzlz,
                  lblCz: {
                    text: '所在地：',
                  },
                  cttCz: {
                    boxClds: [
                      _cr.c(IptC.N, {
                        cz: {
                          iptType: 't',
                          bEdit: _hm.i(pz.sPz.crt.phs, ['c', 'u']),
                          vle: $i11z.i11rz?.i11ra2200s,
                          onChg: (_s: _ht.s) => {
                            _cm.u($i11z.i11rz, {
                              i11ra2200s: _s,
                            });
                            _udtThis();
                          }
                        }
                      }),
                    ]
                  },
                }),
              ]
            },
          ]
        },
        {
          boxStlz: a(`dw/f fd/rec`),
          cellCs: [
            {
              boxClds: [
                _hm.i(pz.sPz.crt.phs, ['c', 'u']) ?
                _cr.c(BtnC.N, {
                  abtz: icv.abtz.btnNext2z,
                  lblCz: {
                    text: '所在地から経度・緯度を設定',
                  },
                  frmCz: {
                    boxStlz: a(`dw/30`),
                    pslPtyz: {
                      onPrs: 
                        _hm.f($i11z.i11rz?.i11ra2200s) ?
                          async () => {
                            const _dz = await icm.cvtLcnAsync($i11z.i11rz?.i11ra2200s)
                            _cm.u($i11z.i11rz, {
                              i11ra7110r: _dz.k,
                              i11ra7120r: _dz.i,
                            });
                            _udtThis();
                          }
                        : undefined,
                    }
                  }
                })
                : undefined,
              ]
            },
          ]
        },

        {
          cellCs: [
            {
              boxClds: [
                _cr.c(LblC.N, {
                  abtz: icv.abtz.lblHzlz,
                  lblCz: {
                    text: '電話番号：',
                  },
                  cttCz: {
                    boxClds: [
                      _cr.c(IptC.N, {
                        cz: {
                          iptType: 't',
                          bEdit: _hm.i(pz.sPz.crt.phs, ['c', 'u']),
                          vle: $i11z.i11rz?.i11ra4100s,
                          onChg: (_s: _ht.s) => {
                            _cm.u($i11z.i11rz, {
                              i11ra4100s: _s,
                            });
                          }
                        }
                      }),
                    ]
                  },
                }),
              ]
            },
          ]
        },
        {
          cellCs: [
            {
              boxClds: [
                _cr.c(LblC.N, {
                  abtz: icv.abtz.lblHzlz,
                  lblCz: {
                    text: '支払方法：',
                  },
                  cttCz: {
                    boxClds: [
                      _cr.c(IptC.N, {
                        cz: {
                          iptType: 'p',
                          bEdit: _hm.i(pz.sPz.crt.phs, ['c', 'u']),
                          ls: $i18rs,
                          vle: $i11z.i11rz?.i11ri18r1f,
                          onChg: (_dz: _ht.dz) => {
                            _cm.u($i11z.i11rz, {
                              i11ri18r1f: _dz.key,
                            });
                          }
                        }
                      }),
                    ]
                  },
                }),
              ]
            },
          ]
        },
        {
          cellCs: [
            {
              boxClds: [
                _cr.c(LblC.N, {
                  abtz: icv.abtz.lblHzlz,
                  lblCz: {
                    text: '契約者：',
                  },
                  cttCz: {
                    boxClds: [
                      _cr.c(IptC.N, {
                        cz: {
                          iptType: 't',
                          bEdit: _hm.i(pz.sPz.crt.phs, ['c', 'u']),
                          vle: $i11z.i11rz?.i11ra3100s,
                          onChg: (_s: _ht.s) => {
                            _cm.u($i11z.i11rz, {
                              i11ra3100s: _s,
                            });
                          }
                        }
                      }),
                    ]
                  },
                }),
              ]
            },
          ]
        },
        {
          cellCs: [
            {
              boxClds: [
                _cr.c(LblC.N, {
                  abtz: icv.abtz.lblHzlz,
                  lblCz: {
                    text: '契約者カナ：',
                  },
                  cttCz: {
                    boxClds: [
                      _cr.c(IptC.N, {
                        cz: {
                          iptType: 't',
                          bEdit: _hm.i(pz.sPz.crt.phs, ['c', 'u']),
                          vle: $i11z.i11rz?.i11ra3120s,
                          onChg: (_s: _ht.s) => {
                            _cm.u($i11z.i11rz, {
                              i11ra3120s: _s,
                            });
                          }
                        }
                      }),
                    ]
                  },
                }),
              ]
            },
          ]
        },
        {
          cellCs: [
            {
              boxClds: [
                _cr.c(LblC.N, {
                  abtz: icv.abtz.lblHzlz,
                  cz: {
                    bMln: true,
                  },
                  lblCz: {
                    text: '備考：',
                  },
                  cttCz: {
                    boxClds: [
                      _cr.c(IptC.N, {
                        cz: {
                          iptType: 't',
                          bEdit: _hm.i(pz.sPz.crt.phs, ['c', 'u']),
                          bMln: true,
                          vle: $i11z.i11rz?.i11ra6100s,
                          onChg: (_s: _ht.s) => {
                            _cm.u($i11z.i11rz, {
                              i11ra6100s: _s,
                            });
                          }
                        }
                      }),
                    ]
                  },
                }),
              ]
            },
          ]
        },
        {
          cellCs: [
            {
              boxClds: [
                _cr.c(LblC.N, {
                  abtz: icv.abtz.lblHzlz,
                  lblCz: {
                    text: '経度：',
                  },
                  cttCz: {
                    boxClds: [
                      _cr.c(IptC.N, {
                        cz: {
                          iptType: 't',
                          bEdit: _hm.i(pz.sPz.crt.phs, ['c', 'u']),
                          vle: $i11z.i11rz?.i11ra7110r,
                          onChg: (_s: _ht.s) => {
                            _cm.u($i11z.i11rz, {
                              i11ra7110r: _s,
                            });
                          }
                        }
                      }),
                    ]
                  },
                }),
              ]
            },
          ]
        },
        {
          cellCs: [
            {
              boxClds: [
                _cr.c(LblC.N, {
                  abtz: icv.abtz.lblHzlz,
                  lblCz: {
                    text: '緯度：',
                  },
                  cttCz: {
                    boxClds: [
                      _cr.c(IptC.N, {
                        cz: {
                          iptType: 't',
                          bEdit: _hm.i(pz.sPz.crt.phs, ['c', 'u']),
                          vle: $i11z.i11rz?.i11ra7120r,
                          onChg: (_s: _ht.s) => {
                            _cm.u($i11z.i11rz, {
                              i11ra7120r: _s,
                            });
                          }
                        }
                      }),
                    ]
                  },
                }),
              ]
            },
          ]
        },
        {
          cellCs: [
            {
              boxStlz: a(`dh/60`),
              boxClds: [
                $i11z.i11rz?.i11ra7110r > 0 && $i11z.i11rz?.i11ra7120r > 0  &&
                _hm.i(pz.sPz.crt.phs, ['c', 'u']) ?
                _cr.c(TextC.N, {
                  key: -20,
                  text: `※ 拡大地図を表示した後、地図上を右クリックすることで、クリックした地点の経度や緯度を確認しクリップボードへコピーすることが可能です`,
                  textStlz: a(`ts/s p/1`),
                  textPtyz: a(`tn/2`),
                })
                : undefined,
                $i11z.i11rz?.i11ra7110r > 0 && $i11z.i11rz?.i11ra7120r > 0 ?
                _cr.c(icm.Map, {
                  key: -10,
                  k: $i11z.i11rz?.i11ra7110r,
                  i: $i11z.i11rz?.i11ra7120r,
                })
                : undefined,
              ]
            },
          ]
        },
      ]
    })

  );

};

const $upsAsync = async (sCfmz: _ht.dz) => {
  await _cmFTH.ugdDzAsync2({
    tgt: 'i11r.ugdI11zDzAsync',
    i11z: $i11z,
  })
  .then((_i11z: _ht.dz) => {
    $i11r_fst = _i11z.i11rz._fst;
  });
};

export const B = (pz: {
  sPz: _ht.dz,
}) => {

  const _sNgnz = useNgnz();
  const _sFilez = useFilez();
  const _sCfmz = useCfmz();

  return (
    _cr.c(BtnsC.N, {
      sPz: pz.sPz,
      abtz: {
        gridBtnz: icv.abtz.gridBtnz,
        btnNextz: icv.abtz.btnNextz,
        btnBackz: icv.abtz.btnBackz,
      },
      cz: {
        tgt: $cz.tgt,
        onCrtAsync: $upsAsync,
        onUdtAsync: $upsAsync,
        atrClds: [

          pz.sPz.crt.steps[0] == 0 ?
          {
            boxClds: [

              _cr.c(BtnC.N, {
                abtz: icv.abtz.btnNextz,
                lblCz: {
                  text: `販売店CSVを出力`,
                },
                frmCz: {
                  pslPtyz: {
                    onPrs: $eptCsv1,
                  }            
                },
              }),

            ]
          }
          : undefined,

          pz.sPz.crt.steps[0] == 0 ?
          {
            boxClds: [

              _cr.c(BtnC.N, {
                abtz: icv.abtz.btnNextz,
                lblCz: {
                  text: `販売店CSVを取込`,
                },
                frmCz: {
                  pslPtyz: {
                    onPrs: () => $iptCsvAsync1({
                      sPz: pz.sPz,
                      sFilez: _sFilez,
                      sCfmz: _sCfmz,
                    }),
                  }            
                },
              }),

            ]
          }
          : undefined,

        ]
      },
    })  
  );

};
